import React from 'react';
import { REGEX_PATTERNS } from '@/shared/config/common/constants/patterns';
import { cn } from '@/shared/lib/classnames/cn';
import type { PhoneNumberProps } from '../model/types';
export const PhoneNumber: React.FC<PhoneNumberProps> = ({
  phone,
  className
}) => {
  const formatPhone = (phoneNumber: string) => {
    const phones = phoneNumber.split(',');
    const mobile = phones[0].replace(REGEX_PATTERNS.NO_DIGITS, '').replace(REGEX_PATTERNS.FORMAT_NUMBER, '+$1 ($2) $3 $4 $5');
    const inner = phones[1] ? `, внутр. н. ${phones[1]}` : '';
    return `${mobile}${inner}`;
  };
  return <span className={cn('text-center text-sm font-bold', className)} data-sentry-component="PhoneNumber" data-sentry-source-file="PhoneNumber.tsx">{formatPhone(phone)}</span>;
};